import { useState } from "react";
import { useTranslation } from "react-i18next";
import { IconBuildingStore, IconDiscountCheck, IconReceipt2 } from "@tabler/icons-react";
import { cn } from "@/lib/utils/cn";
import { ProfileTab } from "../components/ProfileTab";
import { PlanTab } from "../components/PlanTab";
import { SubscriptionSection } from "@/features/subscription/components/SubscriptionSection";

type Tab = "profile" | "plan" | "billing";

export function AgencySettingsPage() {
  const { t } = useTranslation();
  const [tab, setTab] = useState<Tab>("profile");

  const tabs: { id: Tab; label: string; icon: typeof IconBuildingStore }[] = [
    { id: "profile", label: "Perfil da Imobiliária", icon: IconBuildingStore },
    { id: "plan", label: "Plano", icon: IconDiscountCheck },
    { id: "billing", label: t("subscription.tabLabel"), icon: IconReceipt2 },
  ];

  return (
    <div className="space-y-6 max-w-4xl mx-auto">
      <div className="flex flex-col gap-2">
        <h2 className="text-2xl font-bold tracking-tight">Configurações</h2>
        <p className="text-gray-500">
          Gerencie os dados da sua organização e acompanhe o plano contratado.
        </p>
      </div>

      {/* Tabs */}
      <div className="flex gap-1 border-b border-border">
        {tabs.map(({ id, label, icon: Icon }) => (
          <button
            key={id}
            type="button"
            onClick={() => setTab(id)}
            className={cn(
              "inline-flex items-center gap-2 border-b-2 px-4 py-2.5 text-sm font-medium transition-colors",
              tab === id
                ? "border-brand-600 text-brand-700"
                : "border-transparent text-ink-soft hover:text-ink",
            )}
          >
            <Icon size={18} />
            {label}
          </button>
        ))}
      </div>

      {tab === "profile" && <ProfileTab />}
      {tab === "plan" && <PlanTab />}
      {tab === "billing" && <SubscriptionSection />}
    </div>
  );
}
